import { ResendConfirmationEmailMessages, TranslationResendConfirmationEmailMessages } from "@languages/interfaces";

export const messages: TranslationResendConfirmationEmailMessages = {
  [ResendConfirmationEmailMessages.resendConfirmationEmailRequiredEmail]: "Email é obrigatório",
  [ResendConfirmationEmailMessages.resendConfirmationEmailInvalidEmail]: "Email inválido",
  [ResendConfirmationEmailMessages.resendConfirmationEmailTitlePage]: "Reenviar email de confirmação",
  [ResendConfirmationEmailMessages.resendConfirmationEmailLabel]: "Email",
  [ResendConfirmationEmailMessages.resendConfirmationEmailButton]: "Enviar email"
};